@use "../../styles/breakpoint.module.scss" as *;

@property --xcient-gradient-deg {
    syntax: "<angle>";
    inherits: false;
    initial-value: 0deg;
}

@keyframes spin-gradient {
    from {
        --xcient-gradient-deg: 0deg;
    }

    to {
        --xcient-gradient-deg: 360deg;
    }
}

.ctaBlock {
    position: relative;
    padding-block: var(--spacer-104) calc(var(--spacer-120) * 2);

    &::before {
        --gradient-height: 3px;

        content: "";
        position: absolute;
        bottom: calc(100% - var(--gradient-height));
        left: 0;
        width: 100%;
        height: 100px;
        background: conic-gradient(
            from var(--xcient-gradient-deg) at var(--xcient-gradient-position),
            var(--xcient-gradient-stops)
        );
        clip-path: inset(calc(100px - var(--gradient-height)) 0 0 0);
        animation: spin-gradient 10s linear infinite;
    }

    svg {
        position: absolute;
        top: 0;
        right: 0;
        width: var(--spacer-120);
        fill: currentColor;

        @media ($below-mobile) {
            width: var(--spacer-104);
        }
    }
}

.cta {
    display: block;
    position: relative;
    text-align: left;

    &:hover svg {
        transform: translateX(1em);
    }

    svg {
        transform: translateY(0);
        transition: transform 0.2s;
    }
}

.title {
    display: block;
    padding-right: var(--spacer-120);
    font: var(--font-h-64);
}

.subtitle {
    display: block;
    margin-top: var(--spacer-8);
    font: var(--font-button);

    @media ($above-mobile) {
        width: 400px;
        min-width: 33%;
    }
}
